import { storeMixin, storeGenerator } from '@/storeMixin'
import { merge } from 'lodash'

const ccnlcontract = merge(storeMixin.getMixin(), {
  state: {
    apiUrl: '/api/v1/miscellaneous/{profile}/ccnl-contract',
    app: 'miscellaneous'
  }
})

const TYPES = (() =>
  merge(
    storeGenerator(
      { profile: 'GENERIC', app: 'miscellaneous', model: 'ccnlcontract' }
    ),
    { }
  )
)()

export { ccnlcontract, TYPES }
